import Reflux from 'reflux';

export default Reflux.createActions(['setLastRoute']);



// WEBPACK FOOTER //
// ./app/actions/navigationActions.jsx